
import { Component, Vue, Prop } from "vue-property-decorator";
import { PRow } from "@/common/components/look/PRow";
import { PCol } from "@/common/components/look/PCol";

@Component({
  name: "no-data",
  components: {
    PRow,
    PCol,
  },
})
export class NoData extends Vue {
  @Prop({ required: false, default: "empty" }) keyTranslator!: string;
  @Prop({ required: false, default: "noData" }) variant!: string;
}
export default NoData;
